import { separateDecimal } from './separatedNumber';

const ONE_FEET_IN_CM = 30.48;
const ONE_INCH_IN_CM = 2.54;
const ONE_POUNT_IN_GRAMS = 453.592;

export const convertLengthToFeetAndInches = (lengthInCM: number): [number, number] => {
  const feet = lengthInCM / ONE_FEET_IN_CM;
  const feetDecimal = separateDecimal(feet);
  let feetValue = Math.round(feetDecimal.number);
  let inchesValue = Math.round(feetDecimal.decimal * 12);

  // increase by one if inches is 12
  if (inchesValue === 12) {
    inchesValue = 0;
    feetValue += 1;
  }
  return [feetValue, inchesValue];
};

export const convertLengthToCM = (feet: number, inches: number): number => {
  const feetInCm = feet * ONE_FEET_IN_CM;
  const inchesInCm = inches * ONE_INCH_IN_CM;
  const cm = feetInCm + inchesInCm;
  return cm;
};

export const convertInchesToCm = (inches: number): number => {
  const inchesInCm = inches * ONE_INCH_IN_CM;
  return inchesInCm;
};

export const trimNumberToDecimals = (value: number, decimals = 1) => {
  if (decimals < 0) {
    throw new Error(`Decimals must be >= 0.`);
  }
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};

export const convertCmToInches = (cm: number): number => {
  const inchesInCm = cm / ONE_INCH_IN_CM;
  return trimNumberToDecimals(inchesInCm);
};

export const convertPoundsToGrams = (weightInPounds: number): number => {
  return weightInPounds * ONE_POUNT_IN_GRAMS;
};

export const convertGramsToPounds = (weightInGrams: number): number => {
  return weightInGrams / ONE_POUNT_IN_GRAMS;
};
